import React from 'react';
import { Mail, Calendar, TrendingUp, ArrowRight } from 'lucide-react';

const PackagesTeaser = () => {
  const packages = [
    {
      icon: <Mail className="h-8 w-8 text-burnt-orange" />,
      title: "Starter",
      subtitle: "Light Support",
      description: "Great for inbox + calendar + basic follow-through",
      features: [
        "Inbox management",
        "Calendar coordination", 
        "Basic follow-up tasks"
      ]
    },
    {
      icon: <Calendar className="h-8 w-8 text-burnt-orange" />,
      title: "Growth",
      subtitle: "Weekly Ops Support", 
      description: "Great for active projects + coordination + admin systems",
      features: [
        "Project coordination",
        "Admin system setup",
        "Weekly operations support"
      ]
    },
    {
      icon: <TrendingUp className="h-8 w-8 text-burnt-orange" />,
      title: "Executive",
      subtitle: "High-Touch",
      description: "Great for founders with heavy volume + multiple moving parts",
      features: [
        "High-touch support",
        "Multi-project management",
        "Executive-level coordination"
      ]
    }
  ];

  return (
    <section id="packages-teaser" className="section-padding bg-gray-50">
      <div className="container-center">
        {/* Section Header */}
        <div className="text-center space-y-6 mb-16 animate-slide-up">
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-olive-brown">
            Choose the level of support you need.
          </h2>
        </div>

        {/* Packages Grid */}
        <div className="grid lg:grid-cols-3 gap-8 mb-12">
          {packages.map((pkg, index) => (
            <div 
              key={index}
              className="bg-white rounded-3xl p-8 card-shadow hover:shadow-xl transition-all duration-500 animate-slide-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="space-y-6">
                {/* Icon and Title */}
                <div className="space-y-4">
                  <div className="p-4 bg-burnt-orange/20 rounded-2xl w-fit">
                    {pkg.icon}
                  </div>
                  <div>
                    <h3 className="font-display text-2xl font-bold text-olive-brown mb-1">
                      {pkg.title}
                    </h3>
                    <h4 className="text-lg font-semibold text-burnt-orange mb-4">
                      ({pkg.subtitle})
                    </h4>
                  </div>
                </div>

                {/* Description */}
                <p className="text-olive-brown/70 leading-relaxed">
                  {pkg.description}
                </p>

                {/* Features */}
                <div className="space-y-2">
                  {pkg.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-burnt-orange rounded-full mt-2 flex-shrink-0"></div>
                      <span className="text-olive-brown/80 text-sm">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center space-y-4">
          <a
            href="#services-detail"
            className="btn-primary group inline-flex items-center"
            aria-label="View detailed package information"
          >
            View Packages
            <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform duration-300" />
          </a>
          <p className="text-sm text-olive-brown/60">
            No long-term lock-in required to start.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PackagesTeaser;